
import {FC} from "react";
import {useGetComments} from "../../hooks/api/LMS/useGetComments";
import {FlexBox} from "@brg/ui";
import {CommentHomeworkItem} from "./commentHomeworkItem";

export const CommentHomeworkList: FC<{postId: string, t: any}> = ({postId, t}) => {

    const [comments, loading] = useGetComments(postId, t, true)

    return <FlexBox direction="column" directionMobile="column" gy={24}>
        {comments?.map((comment: any) => <CommentHomeworkItem comment={comment} key={comment?.id}/>)}
    </FlexBox>
}
import {FC} from "react";
import {useGetComments} from "../../hooks/api/LMS/useGetComments";
import {FlexBox} from "@brg/ui";
import {CommentHomeworkItem} from "./commentHomeworkItem";

export const CommentHomeworkList: FC<{postId: string, t: any}> = ({postId, t}) => {

    const [comments, loading] = useGetComments(postId, t, true)

    return <FlexBox direction="column" directionMobile="column" gy={24}>
        {comments?.map((comment: any) => <CommentHomeworkItem comment={comment} key={comment?.id}/>)}
    </FlexBox>
}